<template>
  <div>
    <p class="field-label" v-if="label">{{label}}</p>
    <input
      :name="name"
      :type="type"
      v-validate="validation"
      :value="value"
      @input="$emit('updateValue', $event.target.value)"
      :size="(size ? size : placeholder.replace(specialCharacters, '').length) + 5"
      :class="{ white: color === 'white', grey: color === 'grey', 'width-100': size > 50 }"
      @click="onClick"
      :placeholder="placeholder"
    >
  </div>
</template>

<script>
const inputTypes = ['text', 'tel', 'number', 'email', 'password', 'date', 'file', 'hidden']
const colors = ['grey', 'white']

export default {
  name: 'underlined-input',
  inject: ['$validator'],
  data() {
    return {
      specialCharacters: /[&/\\#,+()$~%.'":*?<>{}]/g
    }
  },
  props: {
    type: {
      type: String,
      default: 'text',
      validator: function(value) {
        return inputTypes.indexOf(value) > -1
      }
    },
    name: {
      type: String,
      default: 'input'
    },
    value: {
      required: true
    },
    label: {
      type: String
    },
    placeholder: {
      type: String
    },
    size: {
      type: Number
    },
    color: {
      type: String,
      default: 'white',
      validator: function(value) {
        return colors.indexOf(value) > -1
      }
    },
    onClick: {
      type: Function,
      default: () => {}
    },
    validation: {
      default: ''
    }
  },
  mounted: async function() {},
  model: {
    prop: 'value',
    event: 'updateValue'
  }
}
</script>

<style scoped lang="scss">
@import '../../../scss/config.scss';

input {
  @include normalFontSize();
  font-weight: normal;
  border: none;
  line-height: 18px;
  padding-bottom: 4px;
  height: 18px;
  background: none;
  border-bottom: 1px solid $dividerGrey;
  box-sizing: border-box;
}

.white {
  color: $white;
  border-bottom-color: $white;
}

.grey {
  color: $black;
  border-bottom-color: $dividerGrey;
}

input.white::-webkit-input-placeholder {
  color: $white;
  opacity: 1;
}

input.white::-ms-input-placeholder {
  color: $white;
  opacity: 1;
}

input.white:-ms-input-placeholder {
  color: $white;
  opacity: 1;
}

input.white::placeholder {
  color: $white;
}

input.grey::-ms-input-placeholder {
  color: $grey;
  opacity: 1;
}

input.grey:-ms-input-placeholder {
  color: $grey;
  opacity: 1;
}

input.grey::-webkit-input-placeholder {
  color: $grey;
  opacity: 1;
}

input.grey::placeholder {
  color: $grey;
}

input.grey::placeholder,
input.grey::-moz-placeholder,
input.grey::-webkit-input-placeholder,
input.grey:-ms-input-placeholder,
input.grey::-ms-input-placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: $grey;
  opacity: 1; /* Firefox */
}

.width-100 {
  width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/inputs/UnderlinedInput.vue